import styled from 'styled-components'

export const RightPanel = styled.div`
    background-color: ${props => props.theme.admin.colors.brandDark};
    color: #fff;
    flex-basis: 325px;
    height: calc(100vh - 40px);
    overflow: auto;

    h3 {
        font-size: 1rem;
    }

    hr {
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
    }

    .modal {
        color: ${props => props.theme.admin.colors.brandDark};

        svg {
            fill: ${props => props.theme.admin.colors.brandDark};
        }
    }

    /* Dark Form Styles */

    .form-control:focus {
        box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.32);
    }

    .form-group {
        margin-bottom: 0.5rem;

        label {
            color: ${props => props.theme.admin.editor.text};
            font-size: 0.8rem;
        }

        input:not([type='range']),
        textarea {
            border-radius: 3px;
            background-color: ${props => props.theme.admin.editor.input};
            color: #fff;
            border-color: transparent;

            &:not(:focus):hover {
                border-color: hsl(0, 0%, 70%);
            }
        }

        input:not([type='range']) {
            height: 28px;
        }

        input[type='checkbox'] {
            height: 0;
            width: 0;
            margin: 0;
        }

        button {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    .ck-editor {
        color: #000;
    }

    .checkbox {
        background-color: ${props => props.theme.admin.editor.input};
        border-radius: 3px;
    }

    input:checked + .checkbox:before {
        filter: brightness(10);
    }

    /* Select Styles */

    .peracto-select__control {
        background-color: ${props => props.theme.admin.editor.input};
        color: ${props => props.theme.admin.editor.text};
        border-color: transparent;
        border-radius: 3px;
        min-height: 0;
        height: 30px;
    }

    .peracto-select__control--is-focused {
        border-color: transparent;
        box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.32);

        &:hover {
            border-color: transparent;
        }
    }

    .peracto-select__menu {
        color: #000;
        z-index: 10;
    }

    .peracto-select__single-value {
        color: #fff;
    }

    .peracto-select__dropdown-indicator,
    .peracto-select__value-container {
        padding: 0 8px;
    }

    .peracto-select__dropdown-indicator {
        color: ${props => props.theme.admin.editor.text};
        margin-top: -2px;
    }

    .form-group .peracto-select__value-container input {
        height: auto;
        color: ${props => props.theme.admin.editor.text} !important;
    }

    /* 
     * Tooltips
     *----------------------------------*/
    [data-tooltip] {
        position: relative;
        cursor: pointer;
    }
    [data-tooltip]:before,
    [data-tooltip]:after {
        line-height: 1;
        font-size: 0.9em;
        pointer-events: none;
        position: absolute;
        box-sizing: border-box;
        display: none;
        opacity: 0;
    }
    [data-tooltip]:before {
        content: '';
        border: 5px solid transparent;
        z-index: 100;
    }
    [data-tooltip]:after {
        content: attr(data-tooltip);
        text-align: center;
        min-width: 3em;
        max-width: 21em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 7px 7px;
        border-radius: 3px;
        background: #333333;
        color: #ffffff;
        z-index: 99;
    }
    .tooltip-wrap[data-tooltip]:after {
        white-space: normal;
        min-width: 200px;
        line-height: 1.3;
    }
    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
        display: block;
        opacity: 1;
    }
    [data-tooltip]:not([data-flow]):not(.tooltip-below)::before,
    [data-tooltip]:not(.tooltip-below)::before {
        bottom: 100%;
        border-bottom-width: 0;
        border-top-color: #333333;
    }

    [data-tooltip]:not([data-flow]):not(.tooltip-below)::after,
    [data-tooltip]:not(.tooltip-below)::after {
        bottom: calc(100% + 5px);
    }

    .tooltip-below[data-tooltip]:not([data-flow])::before,
    .tooltip-below[data-tooltip]::before {
        top: 100%;
        border-top-width: 0;
        border-bottom-color: #333333;
    }
    .tooltip-below[data-tooltip]:not([data-flow])::after,
    .tooltip-below[data-tooltip]::after {
        top: calc(100% + 5px);
    }

    [data-tooltip]:not([data-flow])::before,
    [tooltip]:not([data-flow])::after,
    [data-tooltip]::before,
    [data-tooltip]::after {
        left: 50%;
        -webkit-transform: translate(-50%, -4px);
        transform: translate(-50%, -4px);
    }
    [data-tooltip='']::after,
    [data-tooltip='']::before {
        display: none !important;
    }
`
